/* eslint-disable no-restricted-syntax */

import {
  SENDFAILED,
  SENDSUCCEEDED,
  SENDSUCCEEDEDPARTLY,
  NOTIFICATION_TYPE_1_TEXT,
  NOTIFICATION_TYPE_2_TEXT,
  NOTIFICATION_TYPE_3_TEXT,
  NOTIFICATION_TYPE_4_TEXT,
  NOTIFICATION_TYPE_1_CODE,
  NOTIFICATION_TYPE_2_CODE,
  NOTIFICATION_TYPE_3_CODE,
  NOTIFICATION_TYPE_4_CODE,
  NOTIFICATION_TYPE_5_CODE,
  NOTIFICATION_TYPE_5_TEXT,
} from '../../util/Const';

// 送信状況を返すmethod
export const SendStatus = (
  status: number,
  succeeded: number,
  failed: number
) => {
  if (status === undefined) {
    return null;
  }
  switch (status) {
    case 1:
      if (succeeded > 0 && failed === 0) {
        return SENDSUCCEEDED;
      }
      if (succeeded > 0 && failed > 0) {
        return SENDSUCCEEDEDPARTLY;
      }
      return SENDFAILED;
    default:
      return SENDFAILED;
  }
};
// 送信日時を返すmethod
export const GetTimestamp = (timestamp: string | undefined) => {
  if (!timestamp) {
    return '';
  }
  const date = new Date(timestamp);

  return `${date.getFullYear()}/${
    date.getMonth() + 1
  }/${date.getDate()} ${date.getHours()}:${`00${date.getMinutes()}`.slice(-2)}`;
};

// ミリ秒から送信日時を返すmethod
export const GetTimestampForNumber = (timestamp: number | undefined) => {
  if (!timestamp) {
    return '';
  }
  const date = new Date(timestamp);

  return `${date.getFullYear()}/${
    date.getMonth() + 1
  }/${date.getDate()} ${date.getHours()}:${`00${date.getMinutes()}`.slice(-2)}`;
};

// 送信種別を返すmethod
export const GetType = (status: number) => {
  if (status === undefined) {
    return null;
  }
  switch (status) {
    case NOTIFICATION_TYPE_1_CODE:
      return NOTIFICATION_TYPE_1_TEXT;
    case NOTIFICATION_TYPE_2_CODE:
      return NOTIFICATION_TYPE_2_TEXT;
    case NOTIFICATION_TYPE_3_CODE:
      return NOTIFICATION_TYPE_3_TEXT;
    case NOTIFICATION_TYPE_4_CODE:
      return NOTIFICATION_TYPE_4_TEXT;
    case NOTIFICATION_TYPE_5_CODE:
      return NOTIFICATION_TYPE_5_TEXT;
    default:
      return '';
  }
};
